import { Component } from '@theme/component';

export class ProductDetail extends Component {
  requiredRefs = ['tabButton'];

  connectedCallback() {
    super.connectedCallback();

    this.refs.tabButton.forEach(button => button.addEventListener('click', this.handleButtonClick.bind(this)))
  }

  disconnectedCallback() {
    super.disconnectedCallback();
  }

  handleButtonClick(event) {
    const { target } = event.target.dataset

    this.refs.tabButton.forEach(button => {
      button.classList[button.dataset.target === target ? 'add' : 'remove']('active');
    })

    this.refs.tab.forEach(tab => {
      tab.classList[tab.dataset.tab === target ? 'add' : 'remove']('active')

      setTimeout(() => {
        tab.classList[tab.dataset.tab === target ? 'add' : 'remove']('visible')
      })
    })
  }
}

if (!customElements.get('product-detail-component')) {
  customElements.define('product-detail-component', ProductDetail);
}
